<template>
  <div id="app">
    <router-view />
    <van-tabbar v-if="$route.meta.showTabBar" class="TabBar" :fixed="false" v-model="active" route safe-area-inset-bottom>
      <van-tabbar-item push to="/" icon="home-o">首頁</van-tabbar-item>
      <van-tabbar-item push to="/category" icon="apps-o">分類</van-tabbar-item>
      <van-tabbar-item push to="/cart" icon="shopping-cart-o">購物車</van-tabbar-item>
      <van-tabbar-item push to="/member" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
// import {noprintMethod} from '@/api/noprint'
// import store from '@/store'
import Fingerprint2 from 'fingerprintjs2' // 引入fingerprintjs2

export default {
  name: 'App',
  components: {},
  data () {
    return {
      active: 0
    }
  },
  mounted () {
    // noprintMethod(true, true, true, true)

  },
  created () {
    // 在页面加载时读取sessionStorage
    /* if (sessionStorage.getItem('store')) {
      console.log(sessionStorage.getItem('store'))
      store.replaceState(Object.assign({}, store.state, JSON.parse(sessionStorage.getItem('store'))))
      console.log(store.getters.FB)
    }
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      if (store.state) {
        sessionStorage.setItem('store', JSON.stringify(store.state))
        console.log(store.getters.FB)
      }
    }) */
    if (window.requestIdleCallback) {
      requestIdleCallback(() => {
        this.createFingerprint()
      })
    } else {
      setTimeout(() => {
        this.createFingerprint()
      }, 500)
    }
  },
  methods: {
    // 创建浏览器指纹
    createFingerprint () {
      // 浏览器指纹
      Fingerprint2.get((components) => { // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
        const values = components.map(component => component.value) // 配置的值的数组
        const murmur = Fingerprint2.x64hash128(values.join(''), 31) // 生成浏览器指纹
        localStorage.setItem('browserId', murmur) // 存储浏览器指纹，在项目中用于校验用户身份和埋点
      })
    }
  }
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 640px;
  min-width: 320px;
  margin: 0 auto;
  height: 100%;
  background-color: #f5f5f5f8;
}
::-webkit-scrollbar {
  display: none;
  width: 0 !important;
  height: 0 !important;
}
.TabBar {
  max-width: 640px;
  bottom: 0px;
  position: fixed !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue